import { DirectiveBinding } from 'vue/types/options.d';
import { isExit } from './auth';

export default {
  install(instance: any, options = { name: 'auth' }) {
    instance.directive(options.name, {
      inserted(el: HTMLElement, binding: DirectiveBinding) {
        /* eslint-disable no-unused-expressions */
        if (!isExit(binding.value)) el.parentNode && el.parentNode.removeChild(el);
      },
    });
  },
};
